import LogRocket from "logrocket"
import setupLogRocketReact from "logrocket-react"

enum Environment {
  DEV = "dev",
  STAGING = "staging",
}

const isDevOrStaging =
  window.location.hostname.includes(Environment.DEV) ||
  window.location.hostname.includes(Environment.STAGING)

export const setupLogRocket = () => {
  if (isDevOrStaging) {
    LogRocket.init("ksanavira/ksanavira")
    setupLogRocketReact(LogRocket)
  }
}

export const identifyLogRocketUser = (
  id: string,
  name: string,
  email: string
) => {
  if (isDevOrStaging) {
    LogRocket.identify(id, {
      name,
      email,
    })
  }
}
